import { call, put, takeEvery } from "redux-saga/effects";
import {
  getCampaignStatusesList,
  hideCampaignStatusesLoader,
  setCampaignStatusesList,
  setCampaignStatusProfile,
  setCampaignStatusProfileError,
  showCampaignStatusesLoader
} from "./actions";
import {
  ADD_CAMPAIGN_STATUS,
  DELETE_CAMPAIGN_STATUS,
  GET_CAMPAIGN_STATUS_PROFILE,
  GET_CAMPAIGN_STATUSES,
  UPDATE_CAMPAIGN_STATUS_PROFILE
} from "./actionTypes";
import {
  deleteCampaignStatus,
  getCampaignStatuses,
  getCampaignStatusProfile,
  postCampaignStatus,
  putCampaignStatusProfile
} from "../../../helpers/jwt_helper";
import { getErrorMessage, showErrorMessage, showSuccessMessage } from "../../../helpers/utils";

// Chat Redux States
function* onGetCampaignStatuses({ payload: data }) {
  try {
    yield put(showCampaignStatusesLoader());
    let response = yield call(getCampaignStatuses, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({ ...i, description: i.description === "string" ? "" : i.description }))
    };
    yield put(setCampaignStatusesList(response));
    yield put(hideCampaignStatusesLoader());
  } catch (error) {
    yield put(hideCampaignStatusesLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddCampaignStatus({ payload: {status, data } }) {
  try {
    yield put(showCampaignStatusesLoader());
    yield call(postCampaignStatus, {
      name: status.name,
      description: status.description,
      color: status.color,
    });
    yield call(onGetCampaignStatuses, { payload: data });
    yield put(hideCampaignStatusesLoader());
    showSuccessMessage("Campaign status has been added");
  } catch (error) {
    yield put(hideCampaignStatusesLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteCampaignStatus({ payload: { id, data } }) {
  try {
    yield put(showCampaignStatusesLoader());
    yield call(deleteCampaignStatus, id);
    yield call(onGetCampaignStatuses, { payload: data });
    yield put(hideCampaignStatusesLoader());
    showSuccessMessage("Campaign status has been deleted");
  } catch (error) {
    yield put(hideCampaignStatusesLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCampaignStatusProfile({ payload: id }) {
  try {
    yield put(setCampaignStatusProfileError(false));
    let response = yield call(getCampaignStatusProfile, id);
    yield put(setCampaignStatusProfile(response));
  } catch (error) {
    if (getErrorMessage(error) === "Not found.") {
      yield put(setCampaignStatusProfileError(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
  }
}

function* onUpdateCampaignStatusProfile({ payload: { id, status, data } }) {
  try {
    yield put(showCampaignStatusesLoader());
    yield call(putCampaignStatusProfile, id, {
      name: status.name,
      description: status.description,
      color: status.color
    });
    yield call(onGetCampaignStatuses, { payload: data });
    yield put(hideCampaignStatusesLoader());
    showSuccessMessage("Campaign's status has been updated");
  } catch (error) {
    yield put(hideCampaignStatusesLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* campaignStatusesSaga() {
  yield takeEvery(GET_CAMPAIGN_STATUSES, onGetCampaignStatuses);
  yield takeEvery(DELETE_CAMPAIGN_STATUS, onDeleteCampaignStatus);
  yield takeEvery(ADD_CAMPAIGN_STATUS, onAddCampaignStatus);
  yield takeEvery(GET_CAMPAIGN_STATUS_PROFILE, onGetCampaignStatusProfile);
  yield takeEvery(UPDATE_CAMPAIGN_STATUS_PROFILE, onUpdateCampaignStatusProfile);
}

export default campaignStatusesSaga;
